export const missingASMResourceErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('ValueError: Failed to find the requested state machine resource.') !== -1) {
			return {
				type: 'missingASMResourceErrorTest',
				color: 'IndianRed',
				title: 'Missing Animation Resource Error',
				text: 'Outdated/Broken mod is missing required animation resources.',
        description: 'A modification is missing resources required to work properly.</br>' +
        'The modification files could be outdated or you\'re missing an Expansion Pack, Game Pack, or Stuff Pack that includes the required resources.<br/><br/>' +
        'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that could be causing this issue and remove it. Try starting with the oldest modifications you have.<br/>' +
        'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>f6d4067b1c1758065c9c489d</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-03-28 00:09:30</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.67.1020-1.200.000.385.Release</buildsignature>
        <categoryid>asm.py:300</categoryid>
        <desyncid>f6d4067b1c1758065c9c489d</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>[manus] Exception in &lt;class 'sims4.tuning.instances.marketStalls_Tend_Food'&gt;._tuning_loaded_callback. (ValueError: Failed to find the requested state machine resource. Key: 02d5df13:00000000:3e2f295e2b39bfa4)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 150, in c_api_server_init_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\core_services.py&quot;, line 164, in start_service_tick
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\service_manager.py&quot;, line 335, in start_single_service
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 104, in update_incremental_start
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 149, in _execute_gen
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 477, in invoke_registered_callbacks_gen
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\instance_manager.py&quot;, line 475, in invoke_registered_callbacks_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 1639, in _tuning_loaded_callback
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 2229, in _tuning_loaded_callback
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 3953, in _define_supported_postures
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\asm.py&quot;, line 113, in create_asm
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\asm.py&quot;, line 300, in __init__
ValueError: Failed to find the requested state machine resource. Key: 02d5df13:00000000:3e2f295e2b39bfa4
rtim=0</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/missingResourceErrorTest.js